import { render, staticRenderFns } from "./componentLinkBig.vue?vue&type=template&id=5baee509&scoped=true"
import script from "./componentLinkBig.vue?vue&type=script&lang=js"
export * from "./componentLinkBig.vue?vue&type=script&lang=js"
import style0 from "./componentLinkBig.vue?vue&type=style&index=0&id=5baee509&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5baee509",
  null
  
)

export default component.exports